import React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { queriesWorkLogs } from "@query";
import { useSession } from "@hooks/useSession";
import {
  routeHelpersWorkLogPayeeDetails,
  routeHelpersWorkLogPayerDetails,
  routeHelpersWorkLogs
} from "../../paths";

export const RouteWorkLogRedirect: React.FC<
  RouteComponentProps<{ workLogId: string }>
> = props => {
  const { workLogId } = props.match.params;
  const { accountId } = useSession();
  const queryWorkLog = queriesWorkLogs.getWorkLog.useQuery({ workLogId });

  if (queryWorkLog.isLoading) {
    return null;
  }

  const workLog = queryWorkLog.data;

  // TODO(v3): v3 WorkLog drops `payerId`/`payeeId`; the model only carries the
  // owning `accountId`, so the exact payer-vs-payee branch can't be reproduced.
  // Heuristic: owning account === current session account → payer view, otherwise
  // payee view. Both sides are now the v3 `accountId` (from `useSession`), so the
  // earlier v1-userId/v3-accountId id-space mismatch no longer applies.
  if (workLog) {
    if (workLog.accountId === accountId) {
      return (
        <Redirect
          to={routeHelpersWorkLogPayerDetails.createLocationObject({
            workLogId
          })}
        />
      );
    }
    return (
      <Redirect
        to={routeHelpersWorkLogPayeeDetails.createLocationObject({ workLogId })}
      />
    );
  }

  return <Redirect to={routeHelpersWorkLogs.path} />;
};
